<template>
  <div class="vip-sort">
    <el-checkbox v-model="checked" @change="changeVipSort()">
      会员免费课程
    </el-checkbox>
    <el-select
      class="level-select"
      v-model="vipLevel"
      size="small"
      placeholder="全部"
      :disabled="!checked"
      @change="changeVipSort()"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "VipSort",
  props: {
    vipCourse: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      checked: false,
      vipLevel: "",
      options: [],
    };
  },
  watch: {
    //默认值
    vipCourse: {
      immediate: true,
      deep: true,
      handler() {
        this.checked = this.vipCourse.checked;
        this.vipLevel = this.vipCourse.vipLevel;
      },
    },
  },
  async created() {
    //this.options = await this.$http.get("/api/app/vip/all_vip_info");
    this.options.unshift({ name: "全部", id: "" });
  },
  methods: {
    changeVipSort() {
      this.$emit("change", { checked: this.checked, vipLevel: this.vipLevel });
    },
  },
};
</script>
<style lang="scss" scoped>
.vip-sort {
  /deep/ {
    .el-checkbox {
      margin-right: 20px;
    }
    .el-checkbox__label {
      color: #666666;
    }
  }
  .level-select {
    width: 146px;
    height: 28px;
  }
}
</style>
